module.exports = __webpack_public_path__ + "static/media/zoho-logo.5fd7290e.jpg";